/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const validatePortalForGrowthProPlusExposureEarlyRequestRpc = {
  serviceName: 'com.hubspot.growth.post.purchases.rpc.server.GrowthPostPurchasesChirpService',
  rpcName: 'validatePortalForGrowthProPlusExposure',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAC2E1bZDbAGHHAxR8r23tOt',
  earlyRequest: true,
  na1Only: false
};
export const checkHubsForPortalEarlyRequestRpc = {
  serviceName: 'com.hubspot.growth.post.purchases.rpc.server.GrowthPostPurchasesChirpService',
  rpcName: 'checkHubsForPortal',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADfIsqjaG4bbHAxR8r23tOt',
  earlyRequest: true,
  na1Only: false
};
export const getActiveHubsEarlyRequestRpc = {
  serviceName: 'com.hubspot.growth.post.purchases.rpc.server.GrowthPostPurchasesChirpService',
  rpcName: 'getActiveHubs',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACOyeOsZIaOdnAxR8r23tOt',
  earlyRequest: true,
  na1Only: false
};